__turbopack_context__.v({
  "firstScreenSvgText": "AnimatedText-module-scss-module__j9GW6W__firstScreenSvgText",
  "svgTextClass": "AnimatedText-module-scss-module__j9GW6W__svgTextClass",
  "text-clip": "AnimatedText-module-scss-module__j9GW6W__text-clip",
  "text-clip-mob": "AnimatedText-module-scss-module__j9GW6W__text-clip-mob",
  "text-clip-one": "AnimatedText-module-scss-module__j9GW6W__text-clip-one",
  "text-clip-one-two": "AnimatedText-module-scss-module__j9GW6W__text-clip-one-two",
  "text-clip-three": "AnimatedText-module-scss-module__j9GW6W__text-clip-three",
  "text-clip-two": "AnimatedText-module-scss-module__j9GW6W__text-clip-two",
  "textBox": "AnimatedText-module-scss-module__j9GW6W__textBox",
  "textStyleMob_four": "AnimatedText-module-scss-module__j9GW6W__textStyleMob_four",
  "textStyleMob_one": "AnimatedText-module-scss-module__j9GW6W__textStyleMob_one",
  "textStyleMob_three": "AnimatedText-module-scss-module__j9GW6W__textStyleMob_three",
  "textStyleMob_two": "AnimatedText-module-scss-module__j9GW6W__textStyleMob_two",
  "textStyle_one": "AnimatedText-module-scss-module__j9GW6W__textStyle_one",
  "textStyle_one_two": "AnimatedText-module-scss-module__j9GW6W__textStyle_one_two",
  "textStyle_three": "AnimatedText-module-scss-module__j9GW6W__textStyle_three",
  "textStyle_two": "AnimatedText-module-scss-module__j9GW6W__textStyle_two",
});
